import clsx from 'clsx';
// import {LocaleSwitcher} from '../../i18n/locale-switcher';
import {Trans} from '../../i18n/trans';

interface Props {
  className?: string;
  padding?: string;
}

export function Footer({className, padding}: Props) {
  const year = new Date().getFullYear();
  return (
    <footer
      className={clsx(
        'text-sm',
        padding ? padding : 'py-14',
        className,
      )}
    >
      <div className="flex flex-wrap items-center justify-center gap-x-24 gap-y-8 text-muted">
        <Trans
          message="© :year :name"
          values={{year, name: 'Landed'}}
        />
        <a href="/privacy" className="text-muted hover:text-fg transition-colors">
          Privacy Policy
        </a>
        <a href="/terms" className="text-muted hover:text-fg transition-colors">
          Terms of Service
        </a>
        <a href="/contact" className="text-muted hover:text-fg transition-colors">
          Contact Us
        </a>
        <a href="https://features.landed.net/#requests" className="text-muted hover:text-fg transition-colors">
          Feature Requests
        </a>
        <a href="https://features.landed.net/#changelog" className="text-muted hover:text-fg transition-colors">
          Changelog
        </a>
        {/* <LocaleSwitcher /> */}
      </div>
    </footer>
  );
}

